export default {
  DEV_PABITRA: "<@UAC84LKSB>",
};
